import React, { useContext, useEffect, useRef, useState } from "react";
import { BsFillPersonFill } from "react-icons/bs";
import { CiCamera, CiCircleCheck, CiCreditCard1 } from "react-icons/ci";
import { FaLock } from "react-icons/fa";
import { IoCloseCircleOutline } from "react-icons/io5";
import { PiWarningCircleLight } from "react-icons/pi";
import { Link, useNavigate } from "react-router-dom";
import ClientAuthContext from "../../context/ClientAuthContext";
import data1 from "../../data/data.json";
import { serverInstance } from "../../service/axios";
import { isEmpty } from "../../utils/Utils";
import ChangePassword from "./ChangePassword";
import "./client.scss";

const ClientPage = ({ data }) => {
  const { language } = useContext(ClientAuthContext);
  const [state, setState] = useState(true);
  const fileInputRef = useRef(null);
  const bucket = "msid-asset";
  const region = "ap-northeast-2";
  const navigate = useNavigate();
  const { userData, setUserData } = useContext(ClientAuthContext);
  const [unsavedData, setUnsavedData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    mobile_number: "",
    institution: "",
    graduated_year: "",
    diploma_number: "",
    occupation: "",
    workplace: "",
    job: "",
    social_address: "",
    fileUrl: "",
  });
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploaded, setUploaded] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(true);
  const [fileName, setFileName] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("msidclienttoken");
    if (token) {
      serverInstance
        .post(
          "/client",
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          setUserData(res.data.data);
          setUnsavedData(res.data.data);
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          setLoading(false);
        });
    }

    window.scrollTo(0, 0);
  }, []);

  const getUploadUrl = async () => {
    try {
      let response = await serverInstance.post(
        "/client/upload",
        { key: unsavedData.fileUrl },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("msidclienttoken")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        let uploadUrl = response.data.uploadUrl;
        return uploadUrl;
      }
      return undefined;
    } catch (err) {
      console.error(err);
      return undefined;
    }
  };

  const uploadFile = async (uploadUrl) => {
    try {
      let fileBlob = new Blob([file], { type: file.type });
      let response = await fetch(uploadUrl, {
        method: "PUT",
        headers: {
          ContentType: file.type,
        },
        body: fileBlob,
      });
      return true;
    } catch (err) {
      console.error(err);
      return false;
    }
  };

  const deleteOldImage = async (key) => {
    try {
      await serverInstance.delete("/client/upload", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("msidclienttoken")}`,
          "Content-Type": "application/json",
        },
        data: { key: key },
      });
    } catch (err) {
      console.error(err);
    }
  };

  const validate = () => {
    const yearPattern = /^(19|20)\d{2}$/;
    if (!unsavedData.institution.trim()) {
      setErrorMsg(data.institutionRequired);
      return false;
    }
    if (!yearPattern.test(unsavedData.graduated_year)) {
      setErrorMsg(data.invalidYear);
      return false;
    }
    if (!unsavedData.diploma_number.trim()) {
      setErrorMsg(data.diploma_numberRequired);
      return false;
    }
    if (!unsavedData.occupation.trim()) {
      setErrorMsg(data.occupationRequired);
      return false;
    }
    if (!unsavedData.job.trim()) {
      setErrorMsg(data.jobRequired);
      return false;
    }
    const mobilePattern = /^[0-9]{8}$/;
    if (!unsavedData.last_name.trim()) {
      setErrorMsg(data.last_nameRequired);
      return false;
    }
    if (!unsavedData.first_name.trim()) {
      setErrorMsg(data.first_nameRequired);
      return false;
    }
    if (
      !unsavedData.email.trim() ||
      !/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(unsavedData.email)
    ) {
      setErrorMsg(data.invalidEmail);
      return false;
    }
    if (!mobilePattern.test(unsavedData.mobile_number)) {
      setErrorMsg(data.invalidMobile);
      return false;
    }
    if (!unsavedData.workplace.trim()) {
      setErrorMsg(data.workplaceRequired);
      return false;
    }

    return true;
  };

  const save = async (event) => {
    event.preventDefault();
    if (!validate()) {
      return;
    }
    setSuccessMsg("");
    setErrorMsg("");
    setLoading(true);

    if (unsavedData.fileUrl && userData.fileUrl != unsavedData.fileUrl) {
      let uploadUrl = await getUploadUrl();

      if (isEmpty(uploadUrl)) {
        setErrorMsg("Зураг хуулахад үед алдаа гарлаа");
        setLoading(false);
        return false;
      }

      let result = await uploadFile(uploadUrl);
      setUploaded(result);

      if (!result) {
        setErrorMsg("Зураг хуулахад алдаа гарлаа");
        setLoading(false);
        return;
      }
    }

    serverInstance
      .put("/client", unsavedData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("msidclienttoken")}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        let imageToDelete =
          userData.fileUrl && userData.fileUrl !== unsavedData.fileUrl
            ? userData.fileUrl
            : null;
        setUserData(unsavedData);
        setErrorMsg("");
        setSuccessMsg("Амжилттай хадгаллаа.");
        setLoading(false);
        if (uploading) {
          setUploading(false);
        }
        if (imageToDelete) {
          deleteOldImage(imageToDelete);
        }
      })
      .catch((err) => {
        console.error(err);
        setErrorMsg(err?.response?.data?.message || "Хадгалахад алдаа гарлаа");
        setLoading(false);
      });
  };

  const generateFileKeyInS3 = (fileName2) => {
    let fileExt = fileName2.split(".").pop();
    return `client/${userData.id}.${fileExt}`;
  };

  const fileChanges = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    setFileName(selectedFile?.name || "");
    setUnsavedData({
      ...unsavedData,
      fileUrl: generateFileKeyInS3(selectedFile.name),
    });
  };

  const logout = () => {
    localStorage.removeItem("msidclienttoken");
    setUserData({});
    navigate("/");
  };

  return (
    <div className="client-container">
      <div className="container1">
        {userData.fileUrl && !uploading ? (
          <div className="section-row">
            <div className="flex-row">
              <div className="profile-pic" style={{ position: "relative" }}>
                <img
                  src={`https://${bucket}.s3.${region}.amazonaws.com/${unsavedData.fileUrl}`}
                  alt="Зургийн линк"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    borderRadius: "50%",
                  }}
                />
                <div
                  className="cameraContainer"
                  onClick={() => setUploading(true)}
                >
                  <CiCamera color="white" size={20} />
                </div>
              </div>
              <h3>{unsavedData?.first_name}</h3>
            </div>
            <span className="upload-image" onClick={() => setUploading(true)}>
              <IoCloseCircleOutline size={20} />
              &nbsp;{data.changePhoto}
            </span>
          </div>
        ) : null}

        {!userData.fileUrl || uploading ? (
          <div className="section-row">
            <div className="flex-row">
              <div className="profile-pic">
                <div
                  className="cameraContainer"
                  onClick={() => fileInputRef.current?.click()}
                >
                  <CiCamera color="white" size={20} />
                </div>
              </div>
              <h3>{unsavedData?.first_name}</h3>
            </div>
            <input
              type="file"
              name="file"
              accept="image/*"
              ref={fileInputRef}
              onChange={(e) => fileChanges(e)}
              style={{ display: "none" }}
            />
            {fileName ? (
              <p style={{ fontSize: "12px", textWrap: "wrap" }}>
                Сонгосон файл: {fileName}
              </p>
            ) : null}
            {userData.fileUrl && uploading ? (
              <span
                className="recover-file"
                onClick={() => setUploading(false)}
              >
                Файл сэргээх
              </span>
            ) : null}
          </div>
        ) : null}
        <div className="line" />
        <div className="row-flex" onClick={() => setState(true)}>
          <div className="pro-contnr">
            <BsFillPersonFill color="#7C2C61" size={40} />
          </div>
          <h4>{data.title}</h4>
        </div>
        <div className="row-flex" onClick={() => setState(false)}>
          <div className="pro-contnr">
            <FaLock color="#7C2C61" size={35} />
          </div>
          <h4>{data.changePassword}</h4>
        </div>
        <Link to="/membership" className="row-flex">
          <div className="pro-contnr">
            <CiCreditCard1 size={35} color="#7C2C61" />
          </div>
          <h4>{data.membership}</h4>
        </Link>
      </div>
      {state ? (
        <div className="container2">

          <h3>{data.title1}</h3>
          <div className="flex-wrap">
            {userData?.paid_until && new Date(userData.paid_until) > new Date() ? 
              <>
                <label>{data.paid_until}</label>
                <div>{new Date(userData?.paid_until).toLocaleString('mn-MN', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })}
                </div>
              </>
              :
              <>
                <label>{data.noPlan}</label>
                {userData?.paid_until ? `(дууссан: ${new Date(userData.paid_until).toLocaleString('mn-MN', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })})` : ""}
              </>
            }
          </div>

          <h3>{data.title2}</h3>
          <div className="flex-wrap">
            <div className="section-row">
              <label>{data.lname}</label>
              <input
                type="text"
                name="last_name"
                required
                value={unsavedData?.last_name}
                onChange={(e) =>
                  setUnsavedData({ ...unsavedData, last_name: e.target.value })
                }
              />
            </div>
            <div className="section-row">
              <label>{data.fname}</label>
              <input
                type="text"
                name="first_name"
                required
                value={unsavedData?.first_name}
                onChange={(e) =>
                  setUnsavedData({ ...unsavedData, first_name: e.target.value })
                }
              />
            </div>
            <div className="section-row">
              <label>{data.email}</label>
              <input
                type="text"
                name="email"
                className="disabled"
                disabled
                value={userData?.email}
              />
            </div>
            <div className="section-row">
              <label>{data.mnumber}</label>
              <input
                type="text"
                name="mobile_number"
                required
                value={unsavedData?.mobile_number}
                onChange={(e) =>
                  setUnsavedData({
                    ...unsavedData,
                    mobile_number: e.target.value,
                  })
                }
              />
            </div>
            <div className="section-row">
              <label>{data.workplace}</label>
              <input
                type="text"
                name="workplace"
                required
                value={unsavedData?.workplace}
                onChange={(e) =>
                  setUnsavedData({ ...unsavedData, workplace: e.target.value })
                }
              />
            </div>
            <div className="section-row">
              <label>{data.social_address}</label>
              <input
                type="text"
                name="social_address"
                value={unsavedData?.social_address}
                onChange={(e) =>
                  setUnsavedData({
                    ...unsavedData,
                    social_address: e.target.value,
                  })
                }
              />
            </div>
          </div>
          <h3>{data.title3}</h3>
          <div className="flex-wrap">
            <div className="section-row">
              <label>{data.institution}</label>
              <input
                type="text"
                name="institution"
                required
                value={unsavedData?.institution}
                onChange={(e) =>
                  setUnsavedData({
                    ...unsavedData,
                    institution: e.target.value,
                  })
                }
              />
            </div>
            <div className="section-row">
              <label>{data.graduated_year}</label>
              <input
                type="number"
                name="graduated_year"
                required
                value={unsavedData?.graduated_year}
                onChange={(e) =>
                  setUnsavedData({
                    ...unsavedData,
                    graduated_year: e.target.value,
                  })
                }
              />
            </div>
            <div className="section-row">
              <label>{data.diploma_number}</label>
              <input
                type="text"
                name="diploma_number"
                required
                value={unsavedData?.diploma_number}
                onChange={(e) =>
                  setUnsavedData({
                    ...unsavedData,
                    diploma_number: e.target.value,
                  })
                }
              />
            </div>
            <div className="section-row">
              <label>{data.occupation}</label>
              <input
                type="text"
                name="occupation"
                required
                value={unsavedData?.occupation}
                onChange={(e) =>
                  setUnsavedData({ ...unsavedData, occupation: e.target.value })
                }
              />
            </div>
            <div className="section-row">
              <label>{data.job}</label>
              <input
                type="text"
                name="job"
                required
                value={unsavedData?.job}
                onChange={(e) =>
                  setUnsavedData({ ...unsavedData, job: e.target.value })
                }
              />
            </div>
          </div>
          {errorMsg ? (
            <div className="section-row error">
              <PiWarningCircleLight />
              &nbsp;
              {errorMsg}
            </div>
          ) : null}
          {successMsg ? (
            <div className="section-row success-msg">
              <CiCircleCheck />
              &nbsp;
              {successMsg}
            </div>
          ) : null}
          <div className="section-row" style={{ alignSelf: "start" }}>
            <button type="submit" disabled={loading} onClick={save}>
              {data.save}
            </button>
          </div>
        </div>
      ) : (
        <div className="container2">
          <ChangePassword
            data={language ? data1.English.SignUp : data1.Mongolian.SignUp}
          />
        </div>
      )}
    </div>
  );
};

export default ClientPage;
